import axios from './axios'
import utils from './utils'

const load = async (url, signal = null, defaultValue = null, axios_ = null) => {
  try {
    const params = {}
    if (signal) params.signal = signal
    const axiosInstance = axios_ ?? axios
    const res = await axiosInstance.get(url, params)
    return res.data
  } catch (ex) {
    console.error(ex)
    return defaultValue
  }
}

const getAll = async (entity, signal = null, axios_ = null) => {
  const url = `${utils.url}/${entity}`
  return await load(url, signal, [], axios_)
}

const add = async (entity, data, signal = null, throwError = false, axios_ = null) => {
  const url = `${utils.url}/${entity}`
  try {
    const params = {}
    if (signal) params.signal = signal
    const axiosInstance = axios_ ?? axios
    const res = await axiosInstance.post(url, data, params)
    return res.data
  } catch (ex) {
    if (throwError) {
      throw ex
    } else {
      return ex?.response?.data
    }
  }
}

/*
 * data must be a js object with id property
 */
const delete_ = async (entity, id, signal = null, axios_ = null) => {
  const url = `${utils.url}/${entity}/${id}`
  try {
    const params = {}
    if (signal) params.signal = signal
    const axiosInstance = axios_ ?? axios
    const res = await axiosInstance.delete(url, params)
    return res.data
  } catch (ex) {
    //console.error(ex)
    return null
  }
}

const update = async (entity, data, signal = null, throwError = false, axios_ = null) => {
  const url = `${utils.url}/${entity}`
  try {
    const params = {}
    if (signal) params.signal = signal
    const axiosInstance = axios_ ?? axios
    const res = await axiosInstance.put(url, data, params)
    return res.data
  } catch (ex) {
    if (throwError) {
      throw ex
    } else {
      return ex?.response?.data
    }
  }
}

const put = async (url, data, signal = null, axios_ = null) => {
  try {
    const params = {}
    if (signal) params.signal = signal
    const axiosInstance = axios_ ?? axios
    const res = await axiosInstance.put(url, data, params)
    return res.data
  } catch (ex) {
    //console.error(ex)
    return null
  }
}

const post = async (url, data, signal = null, axios_ = null) => {
  try {
    const params = {}
    if (signal) params.signal = signal
    const axiosInstance = axios_ ?? axios
    const res = await axiosInstance.post(url, data, params)
    return res.data
  } catch (ex) {
    //console.error(ex)
    return null
  }
}

const getAllBy = async (parentEntity, parentId, childEntity, signal = null, axios_ = null) => {
  const url = `${utils.url}/${parentEntity}/${parentId}/${childEntity}`
  return await load(url, signal, [], axios_)
}

const get = async (entity, id, signal = null, axios_ = null) => {
  const url = `${utils.url}/${entity}/${id}`
  return await load(url, signal, null, axios_)
}

export default { load, getAll, get, getAllBy, add, update, delete_, put, post }
